var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 722,
    height: 1024,
    viewBox: "0 0 722 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 1024,
    fill: "#E2E5FA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4268_18443",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 722,
    height: 1024
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 722,
    height: 1024,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4268_18443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M705.039 291.15H644.119V352.029H705.039V291.15Z",
    fill: "#5DD5F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2256 418.761H30.8242V435.151H47.2256V418.761Z",
    fill: "#D5FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.379 407.639H125.133V446.859H164.379V407.639Z",
    fill: "#91FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.988 407.054H231.156V446.859H270.988V407.054Z",
    fill: "#8DFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.638 416.419H346.551V437.493H367.638V416.419Z",
    fill: "#C4FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.051 382.468H418.015V471.444H507.051V382.468Z",
    fill: "#0F77B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.174 378.956H520.523V475.542H617.174V378.956Z",
    fill: "#0C4C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.783 378.37H625.961V476.127H723.783V378.37Z",
    fill: "#06466F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5852 498.957H5.05078V567.446H73.5852V498.957Z",
    fill: "#69B9D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.952 496.615H108.731V569.787H181.952V496.615Z",
    fill: "#55AECC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.004 489.591H207.14V577.397H295.004V489.591Z",
    fill: "#247FA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.099 491.933H315.506V574.47H398.099V491.933Z",
    fill: "#2796CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.536 492.518H422.115V573.884H503.536V492.518Z",
    fill: "#3995C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.359 500.713H536.339V565.69H601.359V500.713Z",
    fill: "#47CDF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.21 501.884H643.533V564.519H706.21V501.884Z",
    fill: "#4FD6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2715 599.056H-0.806641V678.081H78.2715V599.056Z",
    fill: "#38A0C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.466 598.471H104.631V679.252H185.466V598.471Z",
    fill: "#2C9EC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.733 600.227H211.826V678.081H289.733V600.227Z",
    fill: "#31A8D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.442 595.543H313.749V681.593H400.442V595.543Z",
    fill: "#2085B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.763 624.227H447.889V654.081H477.763V624.227Z",
    fill: "#B7FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.2 624.812H555.083V652.91H583.2V624.812Z",
    fill: "#ADFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.14 604.324H640.02V673.398H709.14V604.324Z",
    fill: "#2FC1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3427 708.521H2.70801V781.107H75.3427V708.521Z",
    fill: "#31BBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.123 706.764H106.974V782.863H183.123V706.764Z",
    fill: "#2BB1D3"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M768.888 663.447H709.14V723.155H768.888V663.447Z",
    fill: "#91FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.388 663.447H548.055V723.74H608.388V663.447Z",
    fill: "#8DFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.83 677.495H401.613V709.691H433.83V677.495Z",
    fill: "#C4FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.878 625.983H188.98V761.789H324.878V625.983Z",
    fill: "#0F77B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.065 620.715H22.624V767.058H169.065V620.715Z",
    fill: "#0C4C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.56544 619.543H-139.633V767.643H8.56544V619.543Z",
    fill: "#06466F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.246 477.298H683.951V588.519H795.246V477.298Z",
    fill: "#55AECC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.706 466.176H511.737V599.055H644.706V466.176Z",
    fill: "#247FA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.105 470.274H354.752V595.544H480.105V470.274Z",
    fill: "#2796CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.435 470.859H194.839V594.372H318.435V470.859Z",
    fill: "#3995C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.049 483.152H46.0547V582.08H145.049V483.152Z",
    fill: "#47CDF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.104 310.467H678.094V433.396H801.104V310.467Z",
    fill: "#2C9EC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.262 312.809H519.352V431.639H638.262V312.809Z",
    fill: "#31A8D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.034 306.37H351.823V437.493H483.034V306.37Z",
    fill: "#2085B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.775 349.102H234.085V394.761H279.775V349.102Z",
    fill: "#B7FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.932 350.858H74.7568V393.005H116.932V350.858Z",
    fill: "#ADFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.004 153.002H681.022V268.906H797.004V153.002Z",
    fill: "#2BB1D3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBackground);
export default __webpack_public_path__ + "static/media/login_background.e517c8f9f39d8a6a59958abaf36afeb3.svg";
export { ForwardRef as ReactComponent };